import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { fetchBusinessTableItemsByPk, fetchBusinessTableItemsBySk, fetchBusinessTableScan, fetchHrpTableItemsByHccID, fetchHrpTableItemsByPk, fetchHrpTableItemsBySk, fetchHrpTableItemsBySparse, fetchHrpTableScan, fetchItemsByRetryOn } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import DatePicker from "react-datepicker";
import ToggleSwitch from "../shared/ToggleSwitch";
import { getTimeDiff } from "../../utils/commonUtils";
import Select from 'react-select';

const searchOptions = [
    'pk',
    'sk',
].map(str => ({ value: str, label: str }))

const BusinessTable = ({ subscriptionHccId, autoRefreshEnabled: parentAutoRefreshEnabled }) => {

    const now = new Date()

    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localStartOfDayNow = new Date(now.getTime() - timezoneOffsetMs);
    localStartOfDayNow.setHours(0, 0, 0, 0);
    const [showMoreColumns, setShowMoreColumns] = useState(false);


    const [selectedSearchOption, setSelectedSearchOption] = useState(null);
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(parentAutoRefreshEnabled)

    const [selectedDate, setSelectedDate] = useState();

    useEffect(() => {
        setAutoRefreshEnabled(parentAutoRefreshEnabled)

    }, [parentAutoRefreshEnabled])

    useEffect(() => {
        if (subscriptionHccId) {
            setSelectedSearchOption({ value: 'hccId', label: 'hccId' })
            setSearchValue(subscriptionHccId)
            setDecouncedSearchValue(subscriptionHccId)
        }

    }, [subscriptionHccId])

    const { ref, inView } = useInView();

    const queryKey = ['business-table', selectedDate, searchOptions?.value, decouncedSearchValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,
        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchInterval: autoRefreshEnabled ? 1000 * 3 : false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = { lastEvaluatedKey: pageParam };

            if (decouncedSearchValue && selectedSearchOption?.value) {
                // params[selectedSearchOption?.value] = decouncedSearchValue;

                if (selectedSearchOption?.value === 'pk') {
                    return fetchBusinessTableItemsByPk({ ...params, pk: decouncedSearchValue })
                }

                if (selectedSearchOption?.value === 'sk') {
                    return fetchBusinessTableItemsBySk({ ...params, sk: decouncedSearchValue })
                }

            }

            return fetchBusinessTableScan(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    return item
                })).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },
        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    // const resutls = data?.pages.flat()
    const items = data?.pages.flat();

    let columns = ['pk', 'sk', 'bankname', 'bankaccountnumber', 'routingnumber', 'transitnumberpart1', 'transitnumberpart2', 'transitnumberpart3', 'bankaccountnameHrp', 'bankaccountnameJv', 'roles', 'loggedInAt'];

    if (showMoreColumns) {
        columns = [
            ...columns,
            'address', 'city', 'state', 'zip'
        ];
    }

    const today = new Date();
    // today.setDate(today.getDate() + 1);

    return (
        <div className="container">
            {!subscriptionHccId &&
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <div>
                        <p className="title">Business Table</p>
                        <p className="sub-title">Search hints sk: config, bankInfo  </p>
                    </div>
                    <div>
                        <ToggleSwitch
                            label={`Auto Refresh`}
                            onToggle={(val) => setAutoRefreshEnabled(val)}
                            initialState={autoRefreshEnabled}
                        />
                    </div>

                </div>

            }


            {!subscriptionHccId && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <Select
                        name={'searchOptions'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        options={searchOptions}
                        value={selectedSearchOption}
                        onChange={(option) => { setSelectedSearchOption(option) }}
                    />


                    {selectedSearchOption?.value && <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder={'search'}
                        autoComplete="off"
                        onChange={(e) => {

                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />}

                </div>
            </div>}


            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                {subscriptionHccId ? <p></p> : <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {

                        setSelectedSearchOption(null)
                        setSelectedDate(null);
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>}

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"business-table"}
                        columns={columns}
                        items={items}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}


        </div>
    )
}

export default BusinessTable